
<script>
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { searchService } from "../../services";
import { error_message, debounce, success_message } from "../../Helper/helper";
import draggable from "vuedraggable";

export default {
  components: { pagination, searchService, draggable },
  data() {
    const { type,orderBy,sortBy} = this.$route.query;
    return {
      config:config,
      sortBy: sortBy || "reorder",
      sortDesc: orderBy && orderBy != '' ? true : orderBy,
      popular_search: [],
      paginations: {},
      limit: 1,
      search: "",
      type: type == undefined ? '' :type,
      config: config,
      loading: true,
      isDownloading: false,
      popular_search_count: "",
      searchData:debounce(()=>{
        if(!this.init){
          const {type,orderBy,sortBy} = this.$data;
          this.$router.replace({name: 'popular-search', query: {type,orderBy,sortBy}})
        }
        this.getPopularSearchList();
        this.init = false;
      },500),
    };
  },
  mounted() {
    this.getPopularSearchList();
  },
  methods: {
    
    getPopularSearchList(page) {
      this.loading = true;
      var filters = {
        search: this.search,
        type: this.type,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
      }
      searchService
        .getPopularSearchList(filters)
        .then((response) => {
          this.loading = false;
          this.paginations = response.data.result;
          this.popular_search = response.data.result.data;
          this.popular_search_count = response.data.result.data.length;
        });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getPopularSearchList();
    },
    deleteById(id) {
      if (confirm("Are you sure you want to delete?")) {
        searchService.deletePopularSearch({ id: id })
          .then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.getPopularSearchList();
            } else {
              error_message(response.data.message);
            }
          });
      }
    },
    updatePopularSearchOrder: function() {
      var items = this.popular_search.map(function(item, index) {
        return { item: item, order: index }
      });
      if(this.debounce) return
      var ids = items.map(item => item.item.id);

      this.debounce = setTimeout(function(items) {
        this.debounce = false;
        searchService.updatePopularSearchOrder({ ids : ids})
        .then(response => {
          if (response.data.code === 200) {
            this.getPopularSearchList();
          }
        });
      }.bind(this, items), 10)
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
             <h4 class="mb-0 font-size-18">{{ trans.trans('__JSON__.Popular Search') }}({{popular_search_count}})</h4>
          </div>
          <div class="page-title-right d-flex">
            <router-link :to="{name: 'popular-search-add'}" class="btn btn-success btn-rounded mr-2 add-btn"
              v-if="$auth.hasPermission(config.permissions.popular_search_write)">
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get('__JSON__.Add Popular Search') }}
            </router-link>
            <div class="d-flex m-vendor-btn">
              <router-link :to="{name: 'popular-search-add'}" class="btn btn-success btn-rounded mr-2 m-add-btn">
                <i class="mdi mdi-plus"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2">
                <!-- <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Type') }} :</label>
                    <select class="custom-select" v-model="type" @change="searchData()">
                      <option value="">{{ trans.get('__JSON__.All') }}</option>
                      <option value="Category" selected>{{ trans.get('__JSON__.Category') }}</option>
                      <option value="SubCategory">{{ trans.get('__JSON__.Sub Category') }}</option>
                      <option value="Product">{{ trans.get('__JSON__.Product') }}</option>
                      <option value="Brand">{{ trans.get('__JSON__.Brand') }}</option>
                    </select>
                  </div>
                </div> -->
              </div>
              <div class="col-sm-2 offset-sm-8">
                <div class="date-range-list">
                  <label>{{ trans.get('__JSON__.Search') }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="trans.get('__JSON__.Search Placeholder')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list popular-table table-responsive popular-tbl">
                <div class="card task-box popular-tblheader">
                  <div class="card-body menu-items">
                    <div class="media">
                      <div class="tbl-heading mr-4 font-weight-bolder"> # </div>
                      <div class="tbl-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Type') }} </div>
                      <div class="tbl-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Name') }} </div>
                      <div class="tbl-heading mr-4 font-weight-bolder"> {{ trans.get('__JSON__.Action') }} </div>
                    </div>
                  </div>
                </div>
                <draggable class="list-group" group="pop_search" :list="popular_search" v-model="popular_search" @end="updatePopularSearchOrder">
                  <div v-for="pop_search in popular_search" :key="pop_search.id" class="card task-box">
                    <div class="card-body menu-items drag-item">
                      <div class="media">
                        <div class="tbl-heading mr-4">
                          <h5 class="font-size-14">{{pop_search.id}}</h5>
                        </div>

                        <div class="tbl-heading mr-4">
                          <h5 class="font-size-14">{{pop_search.type}}</h5>
                        </div>
                          
                        <div class="tbl-heading mr-4">
                          <span>{{pop_search.name | truncate(40, '...')}}</span>
                        </div>
                        
                        <!-- <div class="tbl-heading mr-4">
                          <div v-if="category.status == '1'"  class="badge badge-pill badge-soft-success font-size-12" >{{ trans.get('__JSON__.Active') }}</div>
                          <div v-else class="badge badge-pill badge-soft-danger font-size-12" >{{ trans.get('__JSON__.Inactive') }}</div>
                        </div> -->

                        <div class="tbl-heading mr-4">
                          <router-link
                            v-if="$auth.hasPermission(config.permissions.popular_search_write)"
                            :to="{name: 'popular-search-edit',params: { id: base64(pop_search.id), type: pop_search.type }}"
                            class="btn btn-success btn-sm btn-rounded cursor-pointer"
                          >{{ trans.get('__JSON__.Edit') }}</router-link>
                          
                          <button
                            v-if="$auth.hasPermission(config.permissions.popular_search_write)"
                            type="submit"
                            class="btn btn-danger btn-sm btn-rounded ml-1"
                            @click="deleteById(base64(pop_search.id))"
                          >{{ trans.get('__JSON__.Delete') }}</button>
                        </div>

                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getPopularSearchList"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<style>
/* .popular-table .table thead th:nth-child(1),.popular-table .table thead th:nth-child(5){
    pointer-events: none;
} */
.popular-tblheader .card-body{
    height: auto;
    background-color: #b3b0b033 !important;
    border-bottom: 0 solid #b3b0b033 !important;
}
.popular-tbl .media{
    align-items: center;
}
.tbl-heading:first-child{
    width: 6rem;
}
.tbl-heading:nth-child(2){
    width: 6rem;
}
.tbl-heading:nth-child(3){
    width: 16rem;
}
.tbl-heading:nth-child(4){
    width: 8rem;
}
.drag-item.menu-items{
  height: auto;
}
</style>